import { render, staticRenderFns } from "./FraudDetail.vue?vue&type=template&id=c83c8b42"
import script from "./FraudDetail.vue?vue&type=script&lang=js"
export * from "./FraudDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports